import React from 'react';
import {
    TextField,
    MenuItem,
    InputAdornment,
    IconButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const StyledSelect = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        backgroundColor: '#fff',
        borderRadius: 8,
        fontSize: '0.9rem',

        '& fieldset': {
            borderColor: '#d0d5dd',
        },
        '&:hover fieldset': {
            borderColor: '#98a2b3',
        },
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main,
            borderWidth: 1.5,
        },
        '& .MuiSelect-select': {
            // Make room for either the arrow or the clear button
            paddingRight: '36px !important',
            padding: '10px 12px',
        },
    },

    '& .MuiInputLabel-root': {
        fontSize: '0.85rem',
        fontWeight: 500,
    },
}));

const StyledMenuItem = styled(MenuItem)({
    fontSize: '0.9rem',
    padding: '10px 12px',
});

const LsSelect = ({
                      label,
                      options = [],
                      value,
                      onChange,
                      placeholder = 'Select...',
                      required = false,
                      error = false,
                      helperText,
                      size = 'small',
                      allowClear = true,
                      MenuProps,
                      ...props
                  }) => {
    const hasValue = Boolean(value);
    const showClear = allowClear && hasValue;

    const handleClear = (e) => {
        e.stopPropagation();
        onChange({ target: { value: '' } });
    };

    return (
        <StyledSelect
            select
            fullWidth
            label={label}
            value={value || ''}
            onChange={onChange}
            required={required}
            error={error}
            helperText={helperText}
            size={size}
            SelectProps={{
                displayEmpty: true,
                // Always a stable component reference — no inline function
                IconComponent: ArrowDropDownIcon,
                MenuProps: {
                    disableScrollLock: true,
                    ...MenuProps,
                    PaperProps: {
                        ...MenuProps?.PaperProps,
                        sx: {
                            maxHeight: 260,
                            ...MenuProps?.PaperProps?.sx,
                        },
                    },
                },
                renderValue: (val) => {
                    if (!val) {
                        return <span style={{ color: '#98a2b3' }}>{placeholder}</span>;
                    }
                    const match = options.find(o => o.value === val);
                    return match?.label || val;
                },
            }}
            InputProps={{
                endAdornment: showClear ? (
                    <InputAdornment position="end" sx={{ position: 'absolute', right: 28 }}>
                        <IconButton
                            size="small"
                            onMouseDown={handleClear} // onMouseDown fires before the Select's onBlur
                            tabIndex={-1}
                        >
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    </InputAdornment>
                ) : null,
            }}
            {...props}
        >
            <StyledMenuItem value="">
                <em>{placeholder}</em>
            </StyledMenuItem>

            {options.map((option) => (
                <StyledMenuItem key={option.value} value={option.value}>
                    {option.label}
                </StyledMenuItem>
            ))}
        </StyledSelect>
    );
};

export default LsSelect;